import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import Close from 'images/pages/home/faq/close.inline.svg';

import styles from './accordion.module.scss';

const cx = classNames.bind(styles);

const QA = [
  {
    question: 'How much does Ghost cost?',
    answer:
      'A discord is provided to customers upon purchasing Phantom, we provide support and suggested release help. Please keep in mind, this discord does NOT have any relation to your purchase of Phantom. Losing access to discord is not our responsibility.',
  },
  {
    question: 'Will I need to pay for updates?',
    answer:
      'A discord is provided to customers upon purchasing Phantom, we provide support and suggested release help. Please keep in mind, this discord does NOT have any relation to your purchase of Phantom. Losing access to discord is not our responsibility.',
  },
  {
    question: 'Is there a Discord/Slack for customers?',
    answer:
      'A discord is provided to customers upon purchasing Phantom, we provide support and suggested release help. Please keep in mind, this discord does NOT have any relation to your purchase of Phantom. Losing access to discord is not our responsibility.',
  },
  {
    question: 'Acceptable payment methods',
    answer:
      'A discord is provided to customers upon purchasing Phantom, we provide support and suggested release help. Please keep in mind, this discord does NOT have any relation to your purchase of Phantom. Losing access to discord is not our responsibility.',
  },
  {
    question: 'What countries are supported?',
    answer:
      'A discord is provided to customers upon purchasing Phantom, we provide support and suggested release help. Please keep in mind, this discord does NOT have any relation to your purchase of Phantom. Losing access to discord is not our responsibility.',
  },
  {
    question: 'I’ve missed a drop. How can I get a copy?',
    answer:
      'A discord is provided to customers upon purchasing Phantom, we provide support and suggested release help. Please keep in mind, this discord does NOT have any relation to your purchase of Phantom. Losing access to discord is not our responsibility.',
  },
  {
    question: 'Is it possible to do a group buy?',
    answer:
      'A discord is provided to customers upon purchasing Phantom, we provide support and suggested release help. Please keep in mind, this discord does NOT have any relation to your purchase of Phantom. Losing access to discord is not our responsibility.',
  },
  {
    question: 'What operating systems are supported?',
    answer:
      'A discord is provided to customers upon purchasing Phantom, we provide support and suggested release help. Please keep in mind, this discord does NOT have any relation to your purchase of Phantom. Losing access to discord is not our responsibility.',
  },
  {
    question:
      'A very long question for testing. A very long question for testing. A very long question for testing. What operating systems are supported?',
    answer:
      'A discord is provided to customers upon purchasing Phantom, we provide support and suggested release help. Please keep in mind, this discord does NOT have any relation to your purchase of Phantom. Losing access to discord is not our responsibility.',
  },
  {
    question: 'What operating systems are supported1?',
    answer:
      'A discord is provided to customers upon purchasing Phantom, we provide support and suggested release help. Please keep in mind, this discord does NOT have any relation to your purchase of Phantom. Losing access to discord is not our responsibility.',
  },
  {
    question: 'What operating systems are supported2?',
    answer:
      'A discord is provided to customers upon purchasing Phantom, we provide support and suggested release help. Please keep in mind, this discord does NOT have any relation to your purchase of Phantom. Losing access to discord is not our responsibility.',
  },
  {
    question: 'What operating systems are supported3?',
    answer:
      'A discord is provided to customers upon purchasing Phantom, we provide support and suggested release help. Please keep in mind, this discord does NOT have any relation to your purchase of Phantom. Losing access to discord is not our responsibility.',
  },
];

const Accordion = ({ id }) => {
  const [openIndex, setOpenIndex] = React.useState(-1);

  return (
    <div className={cx('inner')} id={id}>
      {QA.map(({ question, answer }, i) => (
        <div className={cx('wrapper', 'item')} key={question}>
          <div
            className={cx('header', { 'item-is-open': openIndex === i })}
            role="button"
            onClick={() => (openIndex === i ? setOpenIndex(-1) : setOpenIndex(i))}
          >
            <span className={cx('number')}>{String(i + 1).padStart(2, '0')}</span>
            <p className={cx('question')}>{question}</p>
          </div>
          <div className={cx({ 'visually-hidden': openIndex !== i })}>
            <div className={cx('content')}>
              <p className={cx('answer')}>{answer}</p>
              <button className={cx('close')} type="button" onClick={() => setOpenIndex(-1)}>
                <Close />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
